<script setup>
import { Bar } from 'vue-chartjs';
import 'chart.js/auto';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement } from 'chart.js';
import {computed, onMounted, reactive, ref, nextTick} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

onMounted(async() => {
  await loadData();

  updateChart('48 Hours');
});

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement);
ChartJS.defaults.defaultFontFamily = 'Lato';
ChartJS.defaults.defaultFontSize = 18;
ChartJS.defaults.defaultFontColor = '#000';

const chart = ref(null);

const data = reactive({
  interval: '',
  loaded: false,
  loading: true,
  selected: '',
  offset: true,
  items: [
    '24 Hours',
    '48 Hours',
    '72 Hours'
  ],
  // Chart data and options 24 hours
  chartdata24: {
    labels: [],
    datasets: [
      {
        label: 'Tasks Completed',
        type: 'bar',
        data: [],
        backgroundColor: [
          // Green (Success)
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
        ],
        borderColor: [
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
        ],
        borderWidth: 1,
      },
    ],
  },
  options24: {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Tasks Completed Past 24 hrs',
        fontSize: 25,
      },
      legend: {
        display: false,
        // position: 'bottom',
        // labels: {
        //   fontColor: '#000',
        // },
      },
    },
    responsive: true,
    scales: {
      y:
        {
          ticks: {
            beginAtZero: true,
            // stepSize: 2,
            padding: 5,
          },
        },
      x:
        {
          barPercentage: 0.9,
          categoryPercentage: 0.9,
          gridLines: {
            offsetGridLines: true,
          },
          offset: true,
          ticks: {
            maxRotation: 45,
            minRotation: 45,
            padding: 5,
          },
        },
    },
  },
  // Chart data and options 48 hours
  chartdata48: {
    labels: [],
    datasets: [
      {
        label: 'Tasks Completed',
        type: 'bar',
        data: [],
        backgroundColor: [
          // Green (Success)
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
        ],
        borderColor: [
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
        ],
        borderWidth: 1,
      },
    ],
  },
  options48: {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Tasks Completed Past 48 hrs',
        fontSize: 25,
      },
      legend: {
        display: false,
        // position: 'bottom',
        // labels: {
        //   fontColor: '#000',
        // },
      },
    },
    responsive: true,
    scales: {
      y:
        {
          ticks: {
            beginAtZero: true,
            // stepSize: 1,
            padding: 5,
          },
        },
      x:
        {
          barPercentage: 0.9,
          categoryPercentage: 0.9,
          gridLines: {
            offsetGridLines: true,
          },
          offset: true,
          ticks: {
            maxRotation: 45,
            minRotation: 45,
            padding: 5,
          },
        },
    },
  },
  // Chart data and options 72 hours
  chartdata72: {
    labels: [],
    datasets: [
      {
        label: 'Tasks Completed',
        type: 'bar',
        data: [],
        backgroundColor: [
          // Green (Success)
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
        ],
        borderColor: [
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
        ],
        borderWidth: 1,
      },
    ],
  },
  options72: {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Tasks Completed Past 72 hrs',
        fontSize: 25,
      },
      legend: {
        display: false,
        // position: 'bottom',
        // labels: {
        //   fontColor: '#000',
        // },
      },
    },
    responsive: true,
    scales: {
      y:
        {
          ticks: {
            beginAtZero: true,
            padding: 5,
          },
        },
      x:
        {
          barPercentage: 0.9,
          categoryPercentage: 0.9,
          gridLines: {
            offsetGridLines: true,
          },
          offset: true,
          ticks: {
            maxRotation: 45,
            minRotation: 45,
            padding: 5,
          },
        },
    },
  },
  selectedData: {
    labels: [],
    datasets: [
      {
        label: 'Tasks Completed',
        type: 'bar',
        data: [],
        backgroundColor: [
          // Green (Success)
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
          'rgba(76, 175, 80, 0.25)',
        ],
        borderColor: [
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
          'rgba(76, 175, 80, 1)',
        ],
        borderWidth: 1,
      },
    ],
  },
  selectedOptions: {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Tasks Completed Past 24 hrs',
        fontSize: 25,
      },
      legend: {
        display: false,
        // position: 'bottom',
        // labels: {
        //   fontColor: '#000',
        // },
      },
    },
    responsive: true,
    scales: {
      y:
          {
            ticks: {
              beginAtZero: true,
              // stepSize: 2,
              padding: 5,
            },
          },
      x:
          {
            barPercentage: 0.9,
            categoryPercentage: 0.9,
            gridLines: {
              offsetGridLines: true,
            },
            offset: true,
            ticks: {
              maxRotation: 45,
              minRotation: 45,
              padding: 5,
            },
          },
    },
  }
});

const chartData = computed(() => {
  switch(data.interval) {
    case '24 Hours':
      return data.chartdata24;
    case '48 Hours':
      return data.chartdata48;
    case '72 Hours':
      return data.chartdata72;
    default:
      return data.chartdata24;
  }
});

const chartOptions = computed(() => {
  switch(data.interval) {
    case '24 Hours':
      return data.options24;
    case '48 Hours':
      return data.options48;
    case '72 Hours':
      return data.options72;
    default:
      return data.options24;
  }
});

const loadData = async () => {
  await ApiWrapper.post('tasks-completed-chart', 'tasks-completed-chart', {})
      .then((response) => {
          /** Last 24 hours **/
          let labels24hrs = [];

          for (let i in response.completedTasks24Hours) {
            labels24hrs.push(
                response.completedTasks24Hours[i].description
            );
          }

          data.chartdata24.labels = labels24hrs;

          // Set Chart Data
          let items24hrs = [];

          for (let i in response.completedTasks24Hours) {
            items24hrs.push(
                response.completedTasks24Hours[i].compl
            );
          }

          data.chartdata24.datasets[0].data = items24hrs;


          /** Last 48 hours **/
          // Set Chart Labels
          let labels48hrs = [];

          for (let i in response.completedTasks48Hours) {
            labels48hrs.push(
                response.completedTasks48Hours[i].description
            );
          }

          data.chartdata48.labels = labels48hrs;

          // Set Chart Data
          let items48hrs = [];

          for (let i in response.completedTasks48Hours) {
            items48hrs.push(
                response.completedTasks48Hours[i].compl
            );
          }

          data.chartdata48.datasets[0].data = items48hrs;

          /** Last 72 hours **/
          let labels72hrs = [];

          for (let i in response.completedTasks72Hours) {
            labels72hrs.push(
                response.completedTasks72Hours[i].description
            );
          }

          data.chartdata72.labels = labels72hrs;

          // Set Chart Data
          let items72hrs = [];

          for (let i in response.completedTasks72Hours) {
            items72hrs.push(
                response.completedTasks72Hours[i].compl
            );
          }

          data.chartdata72.datasets[0].data = items72hrs;
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=>{
        data.loading = false;
        data.loaded = true;
      });
}


const updateChart = async (interval) => {
  data.interval = interval;
  nextTick(() => chart.value.chart.update());
}
</script>

<template>
  <v-container id="entreos-resize-target" fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="data.loading" height="25%" style="padding-bottom: 75%">
          <template #progress>
            <v-progress-linear
                color="primary"
                indeterminate
                absolute
            ></v-progress-linear>
          </template>
          <v-select
              :items="data.items"
              :model-value="data.interval"
              density="comfortable"
              variant="solo-filled"
              background="primary"
              label="CHANGE TIME INTERVAL"
              width="33%"
              @update:modelValue="updateChart"
          />
          <Bar ref="chart" :key="data.selected" :data="chartData" :options="chartOptions"/>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
  v-container {
    padding: 5px;
  }
  [v-cloak] {
    display: none;
  }
</style>